import * as React from "react";
import CheckboxOption from "./CheckboxOption";
import { useTypedSelector } from "../state/store";
import LaterQuizItemAddition from "./LaterQuizItemAddition";

var ResearchAgreement = function ResearchAgreement(_a) {
  var item = _a.item;
  var options = item.options;
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer;
  });
  var itemAnswer = quizAnswer.quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });

  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }

  return React.createElement(React.Fragment, null, options.map(function (option) {
    return React.createElement(CheckboxOption, {
      key: option.id,
      item: item
    });
  }));
};

export default ResearchAgreement;